<ng-template #contentTemplate>
    <ng-content></ng-content>
</ng-template>

<a
    *ngIf="isLink; else buttonTemplate"
    [routerLink]="routerLink"
    [ngClass]="className"
    [attr.aria-label]="ariaLabel"
>
    <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
</a>

<ng-template #buttonTemplate>
    <button
        [type]="type"
        [disabled]="disabled"
        [ngClass]="className"
        [attr.aria-label]="ariaLabel"
    >
        <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
    </button>
</ng-template>
